import styles from "../../../styles/Offerings/MobileOfferingPlan.module.css";
const MobileStageOffering = ({ data: offeringDetails }) => {
  return (
    <div className={styles.MobileStageOffering}>
      {offeringDetails.map(({ label, value, highlight, link }, index) => (
        <div key={index} className={styles.MobileStageOfferingContainer}>
          <div>{label}</div>
          <div>
            {value === "Check" ? (
              <img src="/check.svg" alt="Check" width={24} height={24} />
            ) : value === "Wrong" ? (
              <img src="/remove.svg" alt="Wrong" width={24} height={24} />
            ) : link ? (
              <>
                <a href={link} className={styles.link}>
                  {value}
                </a>
                &nbsp; &gt;
              </>
            ) : (
              <div className={highlight ? styles.highlight : ""}>{value}</div>
            )}
          </div>
        </div>
      ))}
      <hr style={{ width: "100%", color: "rgba(119, 119, 119, 1)" }} />
    </div>
  );
};

export default MobileStageOffering;
